import { render, staticRenderFns } from "./Creator.vue?vue&type=template&id=1667febe&scoped=true&"
import script from "./Creator.vue?vue&type=script&lang=js&"
export * from "./Creator.vue?vue&type=script&lang=js&"
import style0 from "./Creator.vue?vue&type=style&index=0&id=1667febe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1667febe",
  null
  
)

export default component.exports